<template>
<div id="self-credit-bureau-list">
  <CreditBureauList :isAllowNavigate="true" :isOnlyContract="true" :isShowSearch="true"></CreditBureauList>
</div>
</template>

<script>
import CreditBureauList from '../../sub_components/CreditBureauList'

export default {
  components: {
    CreditBureauList
  }
}
</script>

<style lang="scss">
</style>
